import React, { useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

function CustomSnackbar({ open, severity, message, onClose }) {
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    onClose(false);
  };

  return (
    <Snackbar open={open} autoHideDuration={6000} onClose={handleSnackbarClose}>
      <MuiAlert elevation={6} variant="filled" onClose={handleSnackbarClose} severity={severity}>
        {message}
      </MuiAlert>
    </Snackbar>
  );
}

export default CustomSnackbar;